<h4>Tags</h4>
<tag-edit-popover
    [tags]="tags"
    [getAllTags]="getAllTags"
    [objectType]="objectType"
    [editable]="false"
></tag-edit-popover>